<ngb-pagination [collectionSize]="pageElementCount" [pageSize]="pageSize" [(page)]="curentPage" (pageChange)="loadPage(curentPage,pageSize)" class="d-flex justify-content-center"
    aria-label="Default pagination ">
    <ng-template ngbPaginationPrevious><span [data-feather]="'chevron-left'" [size]="18"
            [class]="'font-weight-bolder'"></span>
    </ng-template>
    <ng-template ngbPaginationNext><span [data-feather]="'chevron-right'" [size]="18"
            [class]="'font-weight-bolder'"></span></ng-template>
</ngb-pagination>